import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/Markups/ResultsData";

const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) => {
  switch (action.type) {
    case ActionType.MARKUPS_DATA_FETCHED:
      return { ...state, markupsList: action.data };
    case ActionType.MARKUPS_DATA_LIST_ROW_DELETED:
      let newMarkupsList = state.markupsList.filter(item => item.id !== action.data.id);
      return { ...state, markupsList: newMarkupsList };
    default:
      return state;
  }
};

export default updateResultsData;
